import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import BrutalistButton from './BrutalistButton';

export default function AccessWall({ onGrantAccess }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);
  const CORRECT_CODE = 'WRR3MOD26';

  // Immediate check on mount for robust state handling
  useEffect(() => {
    try {
      const unlocked = window.localStorage.getItem('gospelwise-access-unlocked');
      if (unlocked === 'true') {
        onGrantAccess();
      }
    } catch (e) {
      console.error("Storage check failed", e);
    }
  }, [onGrantAccess]);

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    if (code.trim().toUpperCase() === CORRECT_CODE) {
      onGrantAccess();
    } else {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-offwhite flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="bg-white border-4 border-black p-8 shadow-brutal animate-fade-in">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 bg-black text-white flex items-center justify-center font-bold text-2xl">
              <SafeIcon icon={FiIcons.FiLock} />
            </div>
            <div>
              <h1 className="font-bold text-xl uppercase tracking-tight">Protected Content</h1>
              <p className="text-[10px] font-bold text-gray-500 uppercase tracking-widest mt-1">
                GospelWise Author Portal
              </p>
            </div>
          </div>

          <div className="mb-8">
            <p className="text-sm font-medium leading-relaxed text-gray-700">
              This module is exclusive to <span className="text-black font-bold italic">Write. Refine. Release</span> cohort members. Please enter your course access code to proceed.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-xs font-bold uppercase tracking-widest mb-2 text-gray-500">
                Course Access Code
              </label>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="ENTER CODE..."
                className={`w-full bg-offwhite border-2 p-4 font-bold uppercase tracking-widest focus:outline-none transition-all ${
                  error ? 'border-red-500 animate-shake' : 'border-black focus:shadow-brutal-sm'
                }`}
              />
              {error && (
                <p className="text-[10px] font-bold text-red-500 uppercase mt-2">
                  Invalid access code. Please check your course materials.
                </p>
              )}
            </div>

            <BrutalistButton onClick={handleSubmit} variant="primary">
              <div className="flex items-center justify-center gap-2">
                <span>Unlock Module</span>
                <SafeIcon icon={FiIcons.FiArrowRight} />
              </div>
            </BrutalistButton>
          </form>

          <div className="mt-12 pt-6 border-t border-gray-100 flex justify-between items-center">
            <div className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
              Module 3: Edit
            </div>
            <div className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
              v2.0.4
            </div>
          </div>
        </div>
        
        <p className="text-center mt-6 text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          Cross + Pen Services &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}